import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Calendar } from 'lucide-react';

const rankBg = (index) => (
  index === 0 ? 'bg-amber-400 text-white' :
  index === 1 ? 'bg-gray-400 text-white' :
  index === 2 ? 'bg-orange-400 text-white' :
  'bg-gray-200 text-gray-600'
);

export const TrainingAttendanceWidget = ({ trainingAttendance = [], user }) => {
  const rows = trainingAttendance.slice(0, 5);

  return (
    <div className="h-full" data-testid="training-attendance">
      <div className="flex flex-row items-center justify-between pb-4">
        <h3 className="text-xl font-semibold font-title">Training Attendance</h3>
        <Link to="/training">
          <Button variant="ghost" size="sm" style={{ color: user?.menu_color || '#059669' }} className="hover:opacity-80">
            View All
          </Button>
        </Link>
      </div>
      <div className="bg-white rounded-2xl overflow-hidden" style={{ border: '1px solid #e5e2dc' }}>
        {rows.length > 0 ? (
          rows.map((player, index) => (
            <div
              key={player.player_id}
              className={`flex items-center gap-3 px-3 py-2.5 ${index < rows.length - 1 ? 'border-b border-gray-100' : ''}`}
              data-testid={`attendance-row-${player.player_id}`}
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm shrink-0 ${rankBg(index)}`}>
                {index + 1}
              </div>
              <p className="flex-1 min-w-0 font-medium text-gray-900 truncate">{player.name}</p>
              <div className="text-right shrink-0">
                <p className="text-lg font-bold text-teal-600 leading-none">{player.attended}</p>
                <p className="text-xs text-gray-500 mt-0.5">of {player.total_sessions}</p>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8 text-gray-400">
            <Calendar className="w-10 h-10 mx-auto mb-2 opacity-50" strokeWidth={1.5} />
            <p>No training data yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrainingAttendanceWidget;
